import React from 'react'

const Instagram = (
    props: React.SVGProps<SVGSVGElement>
): React.ReactElement => {
    return (
        <svg
            width="32"
            height="30"
            viewBox="0 0 32 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M31.1267 12.8685C29.9324 2.15742 16.4629 -3.63994 7.2408 2.51095C3.48738 5.0119 0.973076 9.15668 0.227772 13.5578C-0.284065 16.5979 0.048177 19.8413 1.41308 22.6427C2.77801 25.4354 5.05876 27.7067 8.02212 28.7847C17.2262 32.152 29.7348 28.5196 31.1267 17.9147C31.3511 16.2444 31.3152 14.5387 31.1267 12.8685Z"
                fill="#534E46"
            />
            <path
                d="M23.3145 20.9106C23.2246 21.3259 23.0989 21.7766 22.7397 22.033C22.4613 22.2273 22.1022 22.2804 21.761 22.307C18.4474 22.6338 13.9756 22.5808 10.6531 22.4306C9.65648 22.3865 8.47106 22.2273 8.03105 21.3702C7.88743 21.0962 7.85152 20.7868 7.81561 20.4864C7.4025 17.0574 7.69889 9.3335 7.95036 8.85616C8.44417 7.90176 9.74618 7.67203 10.8687 7.58362C13.0238 7.39804 15.8883 7.51296 18.6899 7.51296C20.9618 7.51296 22.2997 7.43343 22.7667 7.96366C23.9789 9.36876 23.6378 19.4436 23.3145 20.9106Z"
                fill="white"
                stroke="white"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15.3588 12.515C13.8682 12.6652 12.5033 13.5402 12.3326 15.1044C12.198 16.3417 12.9253 17.5877 14.0927 18.0738C15.0804 18.4892 16.589 18.5688 17.5498 18.0562C18.6274 17.4729 19.1123 16.3152 18.9237 15.1752C18.7082 13.8849 17.8641 12.8067 16.4903 12.5504C16.1401 12.4796 15.7539 12.4709 15.3588 12.515Z"
                fill="#534E46"
                stroke="#534E46"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M20.2701 11.0832C20.2881 10.9948 20.2881 10.8976 20.2791 10.8005C20.1623 9.88132 18.6897 10.0669 18.6088 10.9065C18.582 11.2512 18.8244 11.5958 19.1656 11.693C19.7134 11.852 20.1894 11.5693 20.2701 11.0832Z"
                fill="#534E46"
                stroke="#534E46"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default Instagram
